import styled from 'styled-components';
import { Td, ThCentered } from '../../../components/shared/table/styled';
import { Th } from './../../../components/Operational/table/styled'
import filter from '../../../img/png/ico-filter.png';
import { Card, CardBody } from 'reactstrap';

const ChargeTableTd = styled(Td)`
  padding: 0.7rem 0.9rem !important;
`;

const ChargeTableTh = styled(Th)`
  font-weight: 500;
  padding: 0.85rem 0.9rem !important;
`;

export const BaseEllipsisSpan = styled.span`
  display: -webkit-box;
  max-width: 220px;
  line-height: 1.5;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  padding: 0;
  margin: 0;
`;

export const IdTd = styled(ChargeTableTd)`
  width: 11% !important;
`;

export const BaixarTd = styled(ChargeTableTd)`
  width: 8% !important;
  text-align: center;
`;

export const VencimentoTd = styled(ChargeTableTd)`
  width: 14% !important;
  text-transform: uppercase;
`;

export const CustomersTd = styled(ChargeTableTd)`
  width: 30% !important;
  text-transform: uppercase;
`;

export const ProfileTd = styled(ChargeTableTd)`
  width: 14.5vw !important;
`;

export const ReferenciaTd = styled(ChargeTableTd)`
  width: 16% !important;
  white-space: nowrap;
`;

export const DateTd = styled(ChargeTableTd)`
  width: 14% !important;
`;

export const CancelBaixaTd = styled(ChargeTableTd)`
  width: 8% !important;
`;

export const IconTd = styled(ChargeTableTd)`
  width: 3.3vw !important;
`;

export const CountIndicatorSpan = styled.span`
  margin-left: 5px;
  color: ${props => props.color !== undefined ? props.theme[props.color] : props.theme.color_red};
`;


/**
 * Tags th
 */

export const IdTh = styled(ChargeTableTh)`
  width: 11% !important;
`;

export const BaixarTh = styled(ChargeTableTh)`
  width: 8% !important;
  text-align: center;
`;

export const VencimentoTh = styled(ChargeTableTh)`
  width: 14% !important;
`;

export const CustomersTh = styled(ChargeTableTh)`
  width: 30% !important;
`;

export const ProfileTh = styled(ChargeTableTh)`
  width: 14.5vw !important;
`;

export const ReferenciaTh = styled(ChargeTableTh)`
  width: 16% !important;
`;

export const DateTh = styled(ChargeTableTh)`
  width: 14% !important;
`;

export const CancelBaixaTh = styled(ChargeTableTh)`
  width: 8% !important;
  text-align: center;
`;

export const IconTh = styled(ChargeTableTh)`
  width: 3.3vw !important;
`;

export const FilterHeaderSelect = styled.select`
  width: 98%;
  background-color: transparent;
  border: none;
  border-bottom: solid 1px ${props => props.theme.color_gray};
  color: ${props => props.theme.color_gray};
  font-size: 14px;
  &:focus {
    outline: none;
  }
`;

export const FilterIcon = styled.div`
  background-image: url(${filter});
  background-size: contain;
  background-color: transparent;
  width: 13px;
  height: 13px;
  mask: none;
`;

export const FilterLabel = styled.label`
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
`;

/**
 * Tag tr
 */

export const RequestRow = styled.tr`
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme["table_line-hover"]}!important
  }
`;

export const MobileRequestCard = styled(Card)`
  width: 100%;
  margin: 0 0 10px;
  border: 1px solid rgba(21, 43, 78, 0.12);
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(21, 43, 78, 0.08);
`;

export const MobileRequestCardBody = styled(CardBody)`
  padding: 12px;
`;

export const MobileRequestGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 12px;
`;

export const MobileRequestField = styled.div`
  min-width: 0;
`;

export const MobileRequestLabel = styled.div`
  font-size: 10px;
  color: #7f8ea3;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 3px;
`;

export const MobileRequestValue = styled.div`
  font-size: 13px;
  color: #152b4e;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
`;

export const MobileRequestActionButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  color: #152b4e;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:active,
  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: none;
    background: transparent;
  }
`;